<script>
// Email Icon Component
export const EmailIcon = {
  name: 'EmailIcon',
  render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [
      h('path', {
        attrs: {
          fill: '#0575E6',
          d: 'M23.25 5.25v13.5H.75V5.25h22.5zm-1.5 3.544l-7.89 4.507c-1.153.659-2.567.659-3.72 0L2.25 8.795v8.455h19.5V8.794zm0-2.044H2.25v.316l8.634 4.933c.638.364 1.41.392 2.07.084l.162-.084 8.634-4.934V6.75z'
        }
      })
    ])
  }
}

// ID Icon Component
export const IdIcon = {
  name: 'IdIcon',
  render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [
      h('path', {
        attrs: {
          fill: '#0575E6',
          d: 'M21.6 4.8c1.325 0 2.4 1.075 2.4 2.4V18c0 1.325-1.075 2.4-2.4 2.4H2.4C1.075 20.4 0 19.325 0 18V7.2c0-1.325 1.075-2.4 2.4-2.4h19.2zm0 1.44H2.4c-.49 0-.893.366-.953.84l-.007.12V18c0 .49.366.893.84.953l.12.007h19.2c.49 0 .893-.366.953-.84l.007-.12V7.2c0-.49-.366-.893-.84-.953l-.12-.007zM8.891 14.4c1.054 0 1.909.895 1.909 2v.4h-.89v-.4c0-.663-.386-.8-1.019-.8H4.3c-.627 0-1.005.133-1.005.79v.4H2.4v-.4c0-1.1.85-1.99 1.899-1.99zM6.6 8.4c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 1.2c-.994 0-1.8.806-1.8 1.8s.806 1.8 1.8 1.8 1.8-.806 1.8-1.8-.806-1.8-1.8-1.8zm13.2 1.2c.365 0 .66.295.66.66 0 .328-.24.6-.553.651l-.107.009h-7.2c-.365 0-.66-.295-.66-.66 0-.328.24-.6.553-.651l.107-.009h7.2zm0-2.46c.365 0 .66.295.66.66 0 .328-.24.6-.553.651l-.107.009h-7.2c-.365 0-.66-.295-.66-.66 0-.328.24-.6.553-.651l.107-.009h7.2z'
        }
      })
    ])
  }
}

// Phone Icon Component
export const PhoneIcon = {
  name: 'PhoneIcon',
  render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [
      h('path', {
        attrs: {
          fill: '#0575E6',
          d: 'M16.504.75c1.243 0 2.25 1.007 2.25 2.25v18c0 1.243-1.007 2.25-2.25 2.25H7.508c-1.242 0-2.25-1.007-2.25-2.25V3c0-1.243 1.008-2.25 2.25-2.25h8.996zm.749 19.501H6.757l.001.749c0 .414.336.75.75.75h8.996c.414 0 .75-.336.75-.75l-.001-.749zm0-15.001H6.757v13.501h10.496V5.25zm-.749-3H7.508c-.414 0-.75.336-.75.75l-.001.75h10.496l.001-.75c0-.414-.336-.75-.75-.75z'
        }
      })
    ])
  }
}

// Password Icon Component
export const PasswordIcon = {
  name: 'PasswordIcon',
  render(h) {
    return h('svg', {
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [
      h('path', {
        attrs: {
          d: 'M12 2C9.24 2 7 4.24 7 7v3H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-2V7c0-2.76-2.24-5-5-5zm0 1.5c1.93 0 3.5 1.57 3.5 3.5v3h-7V7c0-1.93 1.57-3.5 3.5-3.5zM5 12h14v8H5v-8zm7 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
          fill: '#0575E6'
        }
      })
    ])
  }
}
</script>



// WEBPACK FOOTER //
// ValidationIcons.vue?9302ebca